import { HeadlandIncreaseUnit } from "@omnia/shared/generated/enums"
import { SeedRateUnit } from "./generated/enums"
import { ISeedRatePlan, NewPlanDefaults } from "./types"

export function getNewPlanDefaultsFromPlan(plan: ISeedRatePlan) {

    if (plan) {

        const {
            UseEstablishmentPct: useEstablishmentPct,
            HeadlandWidth: width,
            HeadlandIncrease: increase,
            HeadlandIncreaseUnit: unit,
        } = plan

        return {
            useEstablishmentPct,
            headland: (width && increase && unit)
                ? {
                    width,
                    increase,
                    unit
                }
                : undefined
        }

    }

    return {
        useEstablishmentPct: false,
        headland: undefined
    }


}


export function getNewPlan(defaults: NewPlanDefaults) {

    const { useEstablishmentPct, headland } = defaults

    const plan: ISeedRatePlan = {

        HoldingId: undefined,
        YearId: undefined,

        Maps: [],
        Name: undefined,
        SeedRatePlanId: undefined,

        CropId: undefined,
        VarietyId: undefined,

        Unit: SeedRateUnit.Kg,

        SeedsQty: undefined,
        SeedsWeight: undefined,

        TGW: undefined,
        GerminationRate: undefined,
        OverlapPct: 0.02,

        UseEstablishmentPct: useEstablishmentPct,

        HeadlandIncrease: headland?.increase,
        HeadlandWidth: headland?.width,
        HeadlandIncreaseUnit: headland?.unit ?? HeadlandIncreaseUnit.Pct,

    }

    return plan

}


/**
 * Compare "defaults" between 2 versions of the same plan, returns true if identical
 */
export function compareDefaults(plan: ISeedRatePlan, original: ISeedRatePlan) {

    if (!original) {
        return false
    }

    return (plan.UseEstablishmentPct == original.UseEstablishmentPct)
        && (plan.HeadlandWidth == original.HeadlandWidth)
        && (plan.HeadlandIncrease == original.HeadlandIncrease)
        && (plan.HeadlandIncreaseUnit == original.HeadlandIncreaseUnit)

}
